import { useEffect } from "react";
import { AiFillEye } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { getDateFromString } from "../../../../redux/slice/invoiceSlice";
import { getDepenseBcsInfo } from "../../../../utils/bcs-status";
import { formatAmout } from "../../../../utils/formatter";
import { getNameLabel } from "../../../../utils/utils";
import BcsStatusBadge from "../../../common/BcsStatusBadge";

const FactureDetail = () => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const { state } = location;
  // Le PDF est le document de référence — y compris pour une facture reçue
  // par la plateforme, archivée dans Storage à l'import. À défaut, la
  // première image du scan.
  const documentUrl: string | undefined =
    state?.pdf || state?.uri || state?.images?.[0];
  useEffect(() => {
    if (!state?.uid) {
      setTimeout(() => {
        navigate(-1);
      }, 10);
    }
  }, [state]);

  return (
    <div className="dashboard-admin-component">
      <div className="container-dashboard-page">
        <div className="admin-page-title-header-container">
          <div className="fast-facture-dash-locataire-requetes-header">
            <h4
              className="fast-facture-dash-header-titre linkable"
              onClick={() => navigate(-1)}
            >
              Facture&gt;{" "}
              <span style={{ fontSize: 16, fontWeight: 400 }}>
                {state?.user?.prenom} {state?.user?.nom}
              </span>
            </h4>
          </div>
        </div>
        <div className="col-left-dashboard col-left-dashboard-responsive mb-3">
          <div className="bg-white p-3">
            <div className="flex-sb align-items-start mb-4">
              <div className="d-flex flex-wrap gap-4">
                {/* Deux statuts distincts, à ne pas confondre : l'état de
                    traitement par le comptable, et le statut de la facture
                    sur la plateforme de facturation électronique. */}
                <div>
                  <p className="title-info-detail-facture mb-2">
                    Traitement comptable
                  </p>
                  {state?.traiter ? (
                    <div className="statut-facture-valide d-inline-block">
                      Validé
                    </div>
                  ) : (
                    <div className="statut-facture-a-traiter d-inline-block">
                      À traiter
                    </div>
                  )}
                </div>
                <div>
                  <p className="title-info-detail-facture mb-2">
                    Facturation électronique
                  </p>
                  <BcsStatusBadge
                    info={state ? getDepenseBcsInfo(state) : undefined}
                    showDetail
                  />
                </div>
              </div>
              <div className="text-end">
                <p className="text-date-facture">
                  Date :{" "}
                  {getDateFromString(state?.date, state?.created_at).format(
                    "DD/MM/YYYY"
                  )}
                </p>
                {documentUrl ? (
                  // Ouverture dans un nouvel onglet : le lecteur PDF du
                  // navigateur permet de consulter, imprimer ou enregistrer.
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-see-more d-inline-flex align-items-center gap-2"
                  >
                    <AiFillEye />
                    Voir la facture
                  </a>
                ) : (
                  <span className="text-muted" style={{ fontSize: 13 }}>
                    Aucun document joint
                  </span>
                )}
              </div>
            </div>
            <div className="container-info-detail-facture mb-4">
              <div className="content-text-detail-facture">
                <p className="title-info-detail-facture">Info pro</p>
              </div>
              <div className="flex-sb">
                <div className="content-info-detail-facture-libelle">
                  <p className="text-detail-facture-libelle">
                    {getNameLabel(state?.type_depense)}
                  </p>
                </div>
                <div className="content-info-detail-facture-value">
                  <p className="text-detail-facture-value">
                    {state?.commerce_name || "Non défini"}
                  </p>
                </div>
              </div>
              {/* <div className="flex-sb">
                <div className="content-info-detail-facture-libelle">
                  <p className="text-detail-facture-libelle">N de siret</p>
                </div>
                <div className="content-info-detail-facture-value">
                  <p className="text-detail-facture-value">0000000000000</p>
                </div>
              </div> */}
            </div>
            <div className="container-info-detail-facture mb-4">
              <div className="content-text-detail-facture">
                <p className="title-info-detail-facture">Info client</p>
              </div>
              <div className="flex-sb">
                <div className="content-info-detail-facture-libelle">
                  <p className="text-detail-facture-libelle">Nom</p>
                </div>
                <div className="content-info-detail-facture-value">
                  <p className="text-detail-facture-value">
                    {state?.user?.prenom} {state?.user?.nom}
                  </p>
                </div>
              </div>
              <div className="flex-sb">
                <div className="content-info-detail-facture-libelle">
                  <p className="text-detail-facture-libelle">Entreprise</p>
                </div>
                <div className="content-info-detail-facture-value">
                  <p className="text-detail-facture-value">
                    {state?.user?.entreprise || "Non défini"}
                  </p>
                </div>
              </div>
            </div>
            <div className="container-info-detail-facture mb-4">
              <div className="content-text-detail-facture">
                <p className="title-info-detail-facture">
                  Montant de la commande
                </p>
              </div>
              <div className="flex-sb">
                <div className="content-info-detail-facture-libelle">
                  <p className="text-detail-facture-montant-libelle">
                    {formatAmout(state?.montant_ht)}HT
                  </p>
                </div>
                <div className="content-info-detail-facture-value">
                  <p className="text-detail-facture-value">
                    TVA {formatAmout(state?.tva)}
                  </p>
                </div>
              </div>
            </div>
            <div className="content-montant-total flex-r">
              <p className="text-montant-total-facture">
                Montant TTC{" "}
                <span
                  style={{ fontWeight: 700, fontSize: 22, paddingLeft: 10 }}
                >
                  {formatAmout(state?.montant_ttc)}{" "}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactureDetail;
